// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boards-header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.boards-header .boards-title {
  flex-grow: 1;
  text-align: center;
  padding: 0px 20px;
}

.boards-search-filter {
  margin: 0px 30px;
}

.board-cards-container,
.board-header-information,
.board-member-item,
.board-members {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.board-cards-container {
  margin-top: 24px;
}
.board-cards-container .board-card {
  width: 90%;
  margin-bottom: 24px;
}
.board-cards-container .board-card .board-details {
  scroll-margin-top: 20px;
  scroll-snap-align: start;
  padding: 24px;
}
.board-cards-container .board-card .board-details .board-header-information {
  flex-direction: column;
}
.board-cards-container .board-card .board-details .board-header-information forge-label-value {
  width: 100%;
  text-align: left;
  margin-top: 15px;
}
.board-cards-container .board-card .board-details .board-members {
  width: 100%;
}
.board-cards-container .board-card .board-details .board-members .board-members-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
}
.board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item {
  flex-wrap: wrap;
  margin: 12px;
  width: 250px;
  word-break: break-all;
  border: none;
}
.board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item .profile-picture {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
}
.board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item .profile-picture .profile-picture-image {
  height: 100px;
  border-radius: 3em;
}
.board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item .board-member-name {
  font-weight: bolder;
}
.board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item .board-member-name,
.board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item .board-member-title,
.board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item .board-member-email {
  text-wrap: wrap;
  width: 100%;
  text-align: center;
}

.boards-navigation {
  overflow: hidden;
}

.navigation {
  position: fixed;
  right: 10%;
  bottom: 10%;
  outline: 0;
  cursor: pointer;
  z-index: 1;
}
.navigation .scroll-to-top-button {
  width: 100px;
  height: 100px;
}

@media only screen and (max-width: 800px) {
  #boardsNavigationScroll {
    width: 0;
  }
}
@media screen and (max-width: 1156px) {
  .board-cards-container {
    margin-top: 12px;
  }
  .board-cards-container .board-card {
    width: 90%;
    margin-bottom: 12px;
  }
  .board-cards-container .board-card .board-details {
    padding: 12px;
    flex-direction: column;
  }
  .board-cards-container .board-card .board-details .board-header-information {
    margin-right: 12px;
    width: 100%;
    max-width: 100%;
  }
  .board-cards-container .board-card .board-details .board-header-information .board-name-description {
    display: flex;
    flex-direction: column;
    text-align: justify;
    width: 100%;
  }
  .board-cards-container .board-card .board-details .board-header-information .contact-details {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    flex-grow: 1;
    width: 100%;
  }
  .board-cards-container .board-card .board-details .board-members {
    width: 100%;
  }
  .board-cards-container .board-card .board-details .board-members .board-members-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
  }
  .board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item {
    flex-wrap: wrap;
    margin: 12px;
    max-width: 250px;
    word-break: break-all;
  }
  .board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item .profile-picture {
    height: 100px;
    border-radius: 3em;
  }
  .board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item .board-member-name,
  .board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item .board-member-title,
  .board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item .board-member-email {
    text-wrap: wrap;
    width: 100%;
    text-align: center;
  }
  .board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item .board-member-title,
  .board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item .board-member-email,
  .board-cards-container .board-card .board-details .board-members .board-members-list .board-member-item .board-member-term {
    color: #2F2F2F;
  }
  .navigation {
    bottom: 5%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/meeting-manager/boards/boards.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AADF;AAGE;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;AADJ;;AAKA;EACE,gBAAA;AAFF;;AAKA;;;;EAIE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;AAGE;EACE,UAAA;EACA,mBAAA;AADJ;AAGI;EACE,uBAAA;EACA,wBAAA;EACA,aAAA;AADN;AAEM;EACE,sBAAA;AAAR;AAEQ;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AAAV;AAIM;EACE,WAAA;AAFR;AAGQ;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;AADV;AAEU;EACE,eAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;AAAZ;AAEY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AAAd;AAEc;EACE,aAAA;EACA,kBAAA;AAAhB;AAIY;EACE,mBAAA;AAFd;AAKY;;;EAGE,eAAA;EACA,WAAA;EACA,kBAAA;AAHd;;AAYA;EACE,gBAAA;AATF;;AAYA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;AATF;AAWE;EACE,YAAA;EACA,aAAA;AATJ;;AAaA;EACE;IACE,QAAA;EAVF;AACF;AAaA;EACE;IACE,gBAAA;EAXF;EAYE;IACE,UAAA;IACA,mBAAA;EAVJ;EAYI;IACE,aAAA;IACA,sBAAA;EAVN;EAWM;IACE,kBAAA;IACA,WAAA;IACA,eAAA;EATR;EAWQ;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,WAAA;EATV;EAYQ;IACE,aAAA;IACA,sBAAA;IACA,yBAAA;IACA,qBAAA;IACA,YAAA;IACA,WAAA;EAVV;EAcM;IACE,WAAA;EAZR;EAaQ;IACE,WAAA;IACA,aAAA;IACA,eAAA;IACA,uBAAA;IACA,uBAAA;EAXV;EAYU;IACE,eAAA;IACA,YAAA;IACA,gBAAA;IACA,qBAAA;EAVZ;EAYY;IACE,aAAA;IACA,kBAAA;EAVd;EAaY;;;IAGE,eAAA;IACA,WAAA;IACA,kBAAA;EAXd;EAcY;;;IAGE,cAAA;EAZd;EAqBA;IACE,UAAA;EAnBF;AACF","sourcesContent":["\n\n.boards-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n\n  .boards-title {\n    flex-grow: 1;\n    text-align: center;\n    padding: 0px 20px;\n  }\n}\n\n.boards-search-filter {\n  margin: 0px 30px;\n}\n\n.board-cards-container,\n.board-header-information,\n.board-member-item,\n.board-members {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.board-cards-container {\n  margin-top: 24px;\n  .board-card {\n    width: 90%;\n    margin-bottom: 24px;\n\n    .board-details {\n      scroll-margin-top: 20px;\n      scroll-snap-align: start;\n      padding: 24px;\n      .board-header-information {\n        flex-direction: column;\n\n        forge-label-value {\n          width: 100%;\n          text-align: left;\n          margin-top: 15px;\n        }\n      }\n\n      .board-members {\n        width: 100%;\n        .board-members-list {\n          width: 100%;\n          display: flex;\n          flex-wrap: wrap;\n          justify-content: center;\n          align-items: flex-start;\n          .board-member-item {\n            flex-wrap: wrap;\n            margin: 12px;\n            width: 250px;\n            word-break: break-all;\n            border: none;\n\n            .profile-picture {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              flex-direction: column;\n              overflow: hidden;\n        \n              .profile-picture-image {\n                height: 100px;\n                border-radius: 3em;\n              }\n            }\n\n            .board-member-name {\n              font-weight: bolder;\n            }\n\n            .board-member-name,\n            .board-member-title,\n            .board-member-email {\n              text-wrap: wrap;\n              width: 100%;\n              text-align: center;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.boards-navigation {\n  overflow: hidden;\n}\n\n.navigation {\n  position: fixed;\n  right: 10%;\n  bottom: 10%;\n  outline: 0;\n  cursor: pointer;\n  z-index: 1;\n  \n  .scroll-to-top-button {\n    width: 100px;\n    height: 100px;\n  }\n}\n\n@media only screen and (max-width: 800px) {\n  #boardsNavigationScroll {\n    width: 0;\n  }\n}\n\n@media screen and (max-width: 1156px) {\n  .board-cards-container {\n    margin-top: 12px;\n    .board-card {\n      width: 90%;\n      margin-bottom: 12px;\n\n      .board-details {\n        padding: 12px;\n        flex-direction: column;\n        .board-header-information {\n          margin-right: 12px;\n          width: 100%;\n          max-width: 100%;  \n\n          .board-name-description {\n            display: flex;\n            flex-direction: column;\n            text-align: justify;\n            width: 100%;\n          }\n          \n          .contact-details {\n            display: flex;\n            flex-direction: column;\n            justify-content: flex-end;\n            align-items: flex-end;\n            flex-grow: 1;\n            width: 100%;\n          }\n        }\n\n        .board-members {\n          width: 100%;\n          .board-members-list {\n            width: 100%;\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: center;\n            align-items: flex-start;\n            .board-member-item {\n              flex-wrap: wrap;\n              margin: 12px;\n              max-width: 250px;\n              word-break: break-all;\n\n              .profile-picture {\n                height: 100px;\n                border-radius: 3em;\n              }\n\n              .board-member-name,\n              .board-member-title,\n              .board-member-email {\n                text-wrap: wrap;\n                width: 100%;\n                text-align: center;\n              }\n\n              .board-member-title,\n              .board-member-email,\n              .board-member-term {\n                color: #2F2F2F;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .navigation {\n    bottom: 5%;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
